export default "__VITE_ASSET__Doal3OJV__"